<script setup lang="ts">
const faqs = useFaqs();
const { fullPath } = useRoute();
const { $scrollTo } = useNuxtApp();

const { data: items } = await useAsyncData("faqs", () => faqs.fetch());

onMounted(() => {
  if (fullPath.includes("faq") && window?.innerWidth < 768) {
    $scrollTo("faq");
  }
});
</script>

<template>
  <div>
    <div class="mb-8 space-y-2">
      <Heading class="scroll-mt-40 !text-xl md:!text-2xl" id="faq">
        {{ $t("contact.faq.title") }}
      </Heading>
      <Paragraph>
        {{ $t("contact.faq.description") }}
      </Paragraph>
    </div>
    <Accordion v-if="items" :items="items" />
  </div>
</template>
